import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule, Routes as AngularRoutes } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './components/home/home.component';
import { Routes } from './utils/utils';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CustomErrorHandler } from './utils/error-handler';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { CommonModule } from '@angular/common';
import { CustomHttpInterceptor } from './utils/http-interceptor';
import { LoaderComponent } from './components/loader/loader.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { InputNumberModule } from 'primeng/inputnumber';
import { NotificationService } from './service/notification.service';
import { MessageService } from 'primeng/api';
import { SettingsComponent } from './components/settings/settings.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { PanelModule } from 'primeng/panel';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CrownsComponent } from './components/crowns/crowns.component';
import { StatsService } from './service/stats.service';
import { AdminComponent } from './components/admin/admin.component';
import { IntroComponent } from './components/intro/intro.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FieldsetModule } from 'primeng/fieldset';
import { PasswordModule } from 'primeng/password';
import { PasswordEyeDirective } from './directives/password-eye.directive';

const routes: AngularRoutes = [
  { path: '', pathMatch: 'full', redirectTo: Routes.HOME },
  { path: Routes.HOME, component: HomeComponent },
  { path: Routes.SETTINGS, component: SettingsComponent },
  { path: Routes.STATISTICS, component: StatisticsComponent },
  { path: Routes.CROWNS, component: CrownsComponent },
  { path: Routes.ADMIN, component: AdminComponent },
  { path: Routes.ERROR, component: ErrorPageComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    MenuModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    ProgressSpinnerModule,
    ToastModule,
    DividerModule,
    TableModule,
    CheckboxModule,
    PanelModule,
    DialogModule,
    InputTextareaModule,
    RadioButtonModule,
    FieldsetModule,
    PasswordModule,
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    PageNotFoundComponent,
    ErrorPageComponent,
    LoaderComponent,
    SettingsComponent,
    StatisticsComponent,
    CrownsComponent,
    AdminComponent,
    IntroComponent,
    PasswordEyeDirective,
  ],
  exports: [RouterModule],
  providers: [
    MessageService,
    NotificationService,
    StatsService,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
